import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js'
import GUI from 'lil-gui'
import {FontLoader} from 'three/examples/jsm/loaders/FontLoader.js'
import {TextGeometry} from 'three/examples/jsm/geometries/TextGeometry.js'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js'

/**
 * Base
 */
// Debug
// Audio setup
// Show loading screen
const loadingScreen = document.createElement('div');
loadingScreen.style.position = 'fixed';
loadingScreen.style.top = '0';
loadingScreen.style.left = '0';
loadingScreen.style.width = '100%';
loadingScreen.style.height = '100%';
loadingScreen.style.backgroundColor = '#000';
loadingScreen.style.color = '#fff';
loadingScreen.style.display = 'none';
loadingScreen.style.justifyContent = 'center';
loadingScreen.style.alignItems = 'center';
loadingScreen.style.fontSize = '24px';
loadingScreen.innerText = 'Loading...';
document.body.appendChild(loadingScreen);

const listener = new THREE.AudioListener();

const audio = new THREE.Audio(listener);
const audioLoader = new THREE.AudioLoader();

// Load the Happy Birthday song
audioLoader.load('/audio/lacongaithattuyet.mp3', (buffer) => {
    audio.setBuffer(buffer);
    audio.setLoop(true); // Play once
    audio.setVolume(0.5); // Adjust volume
});
// Create the "Ready for a surprise?" button
const surpriseButton = document.createElement('button');
surpriseButton.innerText = 'Ready for a surprise?';
surpriseButton.style.position = 'fixed';
surpriseButton.style.top = '50%';
surpriseButton.style.left = '50%';
surpriseButton.style.transform = 'translate(-50%, -50%)';
surpriseButton.style.padding = '15px 30px';
surpriseButton.style.fontSize = '18px';
surpriseButton.style.cursor = 'pointer';
surpriseButton.style.backgroundColor = '#3498db';
surpriseButton.style.color = '#fff';
surpriseButton.style.border = 'none';
surpriseButton.style.borderRadius = '5px';
surpriseButton.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
document.body.appendChild(surpriseButton);

// Scene
const scene = new THREE.Scene()
const axesHelper = new THREE.AxesHelper()
// scene.add(axesHelper)

// Add event listener to the button
surpriseButton.addEventListener('click', () => {
    // Hide the button
    surpriseButton.style.display = 'none';

    // Show the loading screen
    loadingScreen.style.display = 'flex';

    // Start loading assets
    initializeAssets();

});

function initializeAssets() {
    const ambientLightPink = new THREE.AmbientLight(0xffe4e1, 0.7); // Soft pink
    scene.add(ambientLightPink);
    const pointLight1 = new THREE.PointLight(0xffd700, 1, 20); // Gold
    pointLight1.position.set(5, 10, 5);
    scene.add(pointLight1);
    const pointLight2 = new THREE.PointLight(0x87ceeb, 0.7, 20); // Sky blue
    pointLight2.position.set(-5, 8, -5);
    scene.add(pointLight2);


    // Dynamic Spotlights
const spotLight1 = new THREE.SpotLight(0xff69b4, 1.5, 30, Math.PI / 6, 0.5, 2);
spotLight1.position.set(0, 15, 10);
scene.add(spotLight1);
const spotLight2 = new THREE.SpotLight(0x00ffcc, 1.2, 30, Math.PI / 7, 0.5, 2);
spotLight2.position.set(-10, 12, -10);
scene.add(spotLight2);
let spotLightAngle = 0;

// Confetti Particle System
let confettiParticles = [];
const confettiColors = [0xff69b4, 0xffd700, 0x87ceeb, 0x00ffcc, 0xffffff, 0xff6347];
// Add confettiShapes definition for variety
const confettiShapes = ['circle', 'star', 'heart'];
    const confettiGeometry = new THREE.SphereGeometry(0.05, 8, 8);
    // Sparkling confetti shader
    const confettiVertexShader = `
        varying vec3 vPosition;
        void main() {
            vPosition = position;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `;
    const confettiFragmentShader = `
        uniform float time;
        uniform vec3 color;
        varying vec3 vPosition;
        void main() {
            float sparkle = abs(sin(time * 8.0 + vPosition.x * 10.0 + vPosition.y * 10.0));
            float brightness = 0.6 + 0.7 * sparkle;
            gl_FragColor = vec4(color * brightness, 1.0);
        }
    `;
    for (let i = 0; i < 200; i++) {
        const color = new THREE.Color(confettiColors[Math.floor(Math.random() * confettiColors.length)]);
        const shapeType = confettiShapes[Math.floor(Math.random() * confettiShapes.length)];
        const size = 0.04 + Math.random() * 0.06;
        let geometry;
        if (shapeType === 'circle') {
            geometry = new THREE.SphereGeometry(size, 8, 8);
        } else if (shapeType === 'star') {
            geometry = createStarGeometry(size);
        } else if (shapeType === 'heart') {
            geometry = createHeartGeometry(size);
        }
        const material = new THREE.ShaderMaterial({
            uniforms: {
                time: { value: 0 },
                color: { value: color }
            },
            vertexShader: confettiVertexShader,
            fragmentShader: confettiFragmentShader
        });
        const particle = new THREE.Mesh(geometry, material);
        particle.position.x = (Math.random() - 0.5) * 8;
        particle.position.y = Math.random() * 8 + 2;
        particle.position.z = (Math.random() - 0.5) * 8;
        particle.userData = {
            velocity: new THREE.Vector3(
                (Math.random() - 0.5) * 0.05,
                -Math.random() * 0.05 - 0.01,
                (Math.random() - 0.5) * 0.05
            ),
            rotationSpeed: Math.random() * 0.05,
            shaderMaterial: material,
            // trail: Array(trailLength).fill(particle.position.clone()),
            color: color
        };
        scene.add(particle);
        confettiParticles.push(particle);
    }
// Store for animation
window._confettiParticles = confettiParticles;
window._spotLight1 = spotLight1;
window._spotLight2 = spotLight2;
window._spotLightAngle = spotLightAngle; 

    // Gradient background
    const gradientCanvas = document.createElement('canvas');
    gradientCanvas.width = 512;
    gradientCanvas.height = 512;
    const ctx = gradientCanvas.getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 512);
    gradient.addColorStop(0, '#ffb6c1'); // Light pink
    gradient.addColorStop(1, '#87ceeb'); // Light blue
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 512, 512);
    const bgTexture = new THREE.CanvasTexture(gradientCanvas);
    scene.background = bgTexture;
audio.play(); // Start playing the audio
// Create a loading manager
const loadingManager = new THREE.LoadingManager();


// Add spinner
const spinner = document.createElement('div');
spinner.style.border = '8px solid #f3f3f3';
spinner.style.borderTop = '8px solid #3498db';
spinner.style.borderRadius = '50%';
spinner.style.width = '50px';
spinner.style.height = '50px';
spinner.style.animation = 'spin 1s linear infinite';
loadingScreen.appendChild(spinner);


// Add spinner animation (CSS)
const style = document.createElement('style');
style.innerHTML = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
document.head.appendChild(style);
// Hide loading screen when all assets are loaded
loadingManager.onLoad = () => {
    // loadingScreen.style.display = 'none';
    loadingScreen.style.transition = 'opacity 0.5s';
    loadingScreen.style.opacity = '0';
    setTimeout(() => {
        loadingScreen.style.display = 'none';
        window.addEventListener('pointerdown', () => {
            audio.play();
        }, { once: true }); // Ensures the event listener is triggered only once
        // audio.play();
    }, 500);
};

// Update loading progress
loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
    loadingScreen.innerText = `Loading... (${itemsLoaded}/${itemsTotal})`;
};

// Handle errors
loadingManager.onError = (url) => {
    console.error(`There was an error loading ${url}`);
};
// const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// (Moved above to ensure scene is defined before use)
/**
 * Textures
 */
const thirdTexture = new THREE.TextureLoader().load('/textures/matcaps/3.png')
const chocolateTexture = new THREE.TextureLoader().load('/textures/matcaps/1006_baseColor.png')
chocolateTexture.colorSpace = THREE.SRGBColorSpace
const cakeTexture = new THREE.TextureLoader().load('/textures/matcaps/1007_baseColor.png')
cakeTexture.colorSpace = THREE.SRGBColorSpace
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('/textures/matcaps/8.png')
matcapTexture.colorSpace = THREE.SRGBColorSpace
/**
 * Fonts
 */
let cakes = [];
const gltfLoader = new GLTFLoader(loadingManager)

const directionalLight = new THREE.DirectionalLight(0xffffff, 1.2);
directionalLight.position.set(10, 20, 10);
scene.add(directionalLight);
// Load heart shell as 'earth' covering all cakes
let heartEarth;
gltfLoader.load('/models/heart_in_love_gtlf.glb', (gltf) => {
    heartEarth = gltf.scene;
    heartEarth.scale.set(20, 20, 20); // Large enough to cover cakes
    heartEarth.position.set(0, 0, 0);
    heartEarth.traverse((child) => {
        if (child.isMesh) {
            // Replace material with MeshPhongMaterial for lighting
            // child.material = new THREE.MeshPhongMaterial({
            //     color: child.material.color,
            //     side: THREE.DoubleSide,
            //     transparent: true,
            //     opacity: 0.5,
            //     shininess: 80,
            //     specular: 0xffffff
            // });
            child.material.side = THREE.DoubleSide;
            child.material.transparent = true;
            child.material.opacity = 0.5; // See-through effect

        }
    });
    scene.add(heartEarth);
});

const fontLoader = new FontLoader(loadingManager)
fontLoader.load('/fonts/helvetiker_regular.typeface.json',
    (font) => {
        const textGeometry = new TextGeometry('Thank you for making science make sense (^-^)', {
            font,
            size: 0.5,
            depth: 0.2,
            curveSegments: 12,
            bevelEnabled: true,
            bevelThickness: 0.03,
            bevelSize: 0.02,
            bevelOffset: 0,
            bevelSegments: 5
        })
        //         const textMaterial = new THREE.MeshMatcapMaterial({matcap: matcapTexture})
        // const chocolateMaterial = new THREE.MeshStandardMaterial({map: chocolateTexture})
        // const cakeMaterial = new THREE.MeshStandardMaterial({map: cakeTexture})
        // const textMesh = new THREE.Mesh(textGeometry,[cakeMaterial,chocolateMaterial])
        // textGeometry.center()
        // // const text = new THREE.Mesh(textGeometry, textMaterial)
        // // textGeometry.center()
        // scene.add(textMesh)

        // Shining effect: MeshStandardMaterial with emissive color
        const shinyMaterial = new THREE.MeshStandardMaterial({map: thirdTexture})
        const shinyTextMaterial = new THREE.MeshStandardMaterial({
            color: 0xffffff,
            metalness: 0.8,
            roughness: 0.2,
            emissive: 0xffb6c1,
            emissiveIntensity: 1.0
        });
        const textMesh = new THREE.Mesh(textGeometry, [shinyTextMaterial, shinyMaterial]);
        textGeometry.center();
        scene.add(textMesh);
        // Store reference for animation
        window._shinyTextMaterial = shinyTextMaterial;
        // console.time('donuts')
        // const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)
        // const donutMaterial = new THREE.MeshMatcapMaterial({matcap: matcapTexture})
        // for (let i = 0; i < 100; i++) {
         
        //     const donut = new THREE.Mesh(donutGeometry, donutMaterial)
        //     donut.position.x = (Math.random() - 0.5) * 10 
        //     donut.position.y = (Math.random() - 0.5) * 10
        //     donut.position.z = (Math.random() - 0.5) * 10
        //     donut.rotation.x = Math.random() * Math.PI
        //     donut.rotation.y = Math.random() * Math.PI

        //     const scale = Math.random()
        //     donut.scale.x = scale
        //     donut.scale.y = scale
        //     donut.scale.z = scale
        //     scene.add(donut) 
            
        // }
        // console.timeEnd('donuts')
        const rosePath = '/red_rose/converted_scene.gltf';
        gltfLoader.load(rosePath, (gltf) => {
            const roseModel = gltf.scene;
            console.log(roseModel);
            console.time('roses');

            // Load rose textures
            const textureLoader = new THREE.TextureLoader(loadingManager);

            const roseTextureURL = '/red_rose/textures/Red_rose_diffuse.jpeg';
            const roseNormalURL = '/red_rose/textures/Red_rose_normal.png';
            const roseOcclusionURL = '/red_rose/textures/Red_rose_occlusion.png';

            textureLoader.load(
                roseTextureURL,
                // onLoad callback
                (roseTexture) => {
                    const roseNormal = textureLoader.load(roseNormalURL);
                    const roseOcclusion = textureLoader.load(roseOcclusionURL);

                    // Set correct texture properties
                    roseTexture.colorSpace = THREE.SRGBColorSpace;
                    roseTexture.flipY = false;
                    roseNormal.flipY = false;
                    roseOcclusion.flipY = false;

                    const roseMaterial = new THREE.MeshPhysicalMaterial({
                        map: roseTexture,
                        normalMap: roseNormal,
                        aoMap: roseOcclusion,
                        normalScale: new THREE.Vector2(0.7, 0.7),
                        metalness: 0.0,
                        roughness: 0.9, // Adjusted for a more matte look
                        envMapIntensity: 1.0,
                        side: THREE.DoubleSide,
                        emissive: 0xffffff,
                        emissiveMap: roseTexture,
                        emissiveIntensity: 0.3
                    });

                    for (let i = 0; i < 200; i++) {
                        const rose = roseModel.clone();

                        rose.traverse((child) => {
                            if (child.isMesh) {
                                child.material = roseMaterial;
                                if (child.geometry.attributes.uv && !child.geometry.attributes.uv2) {
                                    child.geometry.setAttribute('uv2', child.geometry.attributes.uv.clone());
                                }
                            }
                        });

                        // Randomize position, rotation, and scale
                        rose.position.set(
                            (Math.random() - 0.5) * 10,
                            (Math.random() - 0.5) * 10,
                            (Math.random() - 0.5) * 10
                        );
                        rose.rotation.set(
                            Math.random() * Math.PI,
                            Math.random() * Math.PI,
                            0
                        );
                        const scale = Math.random() * 0.3 + 0.2;
                        rose.scale.set(scale, scale, scale);

                        scene.add(rose);
                        cakes.push(rose);
                    }
                    console.timeEnd('roses');
                },
                // onProgress callback (optional)
                undefined,
                // onError callback
                (err) => {
                    console.error('An error happened loading the rose texture.', err);
                }
            );
        });
    }
)


/**
 * Object
 */
// const cube = new THREE.Mesh(
//     new THREE.BoxGeometry(1, 1, 1),
//     new THREE.MeshBasicMaterial()
// )

// scene.add(cube)
const ambientLight = new THREE.AmbientLight(0xffffff, 1); // Bright white light
scene.add(ambientLight);
/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
camera.position.set(0, 0, 50);
scene.add(camera)

camera.add(listener); // Attach the listener to the camera
// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.minDistance = 1;
controls.maxDistance = 50;
controls.minPolarAngle = 0; // Allow looking straight up
controls.maxPolarAngle = Math.PI; // Allow looking straight down
// const controls = new TrackballControls(camera, canvas)
// controls.rotateSpeed = 4.0
// controls.zoomSpeed = 1.2
// controls.panSpeed = 0.8
// controls.staticMoving = true
// controls.dynamicDampingFactor = 0.3
// controls.minDistance = 1
// controls.maxDistance = 50
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.outputColorSpace = THREE.SRGBColorSpace
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.toneMappingExposure = 1.0
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Bloom composer setup
const composer = new EffectComposer(renderer)
composer.addPass(new RenderPass(scene, camera))
const bloomPass = new UnrealBloomPass(
    new THREE.Vector2(sizes.width, sizes.height),
    1.5, // strength
    1.0, // radius
    0.9  // threshold
)
composer.addPass(bloomPass)

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
     // Camera zoom-in animation
    const zoomDuration = 10; // Duration of the zoom-in animation in seconds
     if (elapsedTime < zoomDuration) {
         const progress = elapsedTime / zoomDuration; // Progress from 0 to 1
         camera.position.z = 40 - (38 * progress); // Start at z = 20, end at z = 2
     }
     cakes.forEach(cake => {
        cake.rotation.y += 0.01;
        cake.rotation.x += 0.01;
        cake.rotation.z += 0.01;
        // Animate candle flames
        // if (cake.userData && cake.userData.flames) {
        //     cake.userData.flames.forEach(flame => {
        //         if (flame.material && flame.material.uniforms && flame.material.uniforms.time) {
        //             flame.material.uniforms.time.value = clock.getElapsedTime();
        //         }
        //     });
        // }
     })
    // Animate shining text
    if (window._shinyTextMaterial) {
        // Pulsate the emissive intensity for a shining effect
        window._shinyTextMaterial.emissiveIntensity = 1.2 + Math.sin(clock.getElapsedTime() * 3) * 0.8;
    }
     
    
    // Animate confetti particles and sparkle
    if (window._confettiParticles) {
        const sparkleTime = clock.getElapsedTime();
        window._confettiParticles.forEach(particle => {
            particle.position.add(particle.userData.velocity);
            particle.rotation.x += particle.userData.rotationSpeed;
            particle.rotation.y += particle.userData.rotationSpeed;
            // Sparkle animation
            if (particle.userData.shaderMaterial) {
                particle.userData.shaderMaterial.uniforms.time.value = sparkleTime;
            }
            // Reset if below ground
            if (particle.position.y < -2) {
                particle.position.x = (Math.random() - 0.5) * 8;
                particle.position.y = Math.random() * 8 + 2;
                particle.position.z = (Math.random() - 0.5) * 8;
            }
        });
    }
// Animate spotlights
if (window._spotLight1 && window._spotLight2) {
    window._spotLightAngle += 0.02;
    window._spotLight1.position.x = Math.sin(window._spotLightAngle) * 10;
    window._spotLight1.position.z = Math.cos(window._spotLightAngle) * 10;
    window._spotLight2.position.x = Math.cos(window._spotLightAngle) * 10;
    window._spotLight2.position.z = Math.sin(window._spotLightAngle) * 10;
}
// Animate heartEarth beating
if (heartEarth) {
    // Create a heartbeat effect
    const beatSpeed = 2; // Speed of the heartbeat
    const beatStrength = 0.15; // How strong the beat effect is
    const baseScale = 20; // The base scale we set earlier
    
    // Create a more natural heartbeat pattern with two beats
    const t = elapsedTime * beatSpeed;
    const beat1 = Math.pow(Math.sin(t), 8); // Sharp first beat
    const beat2 = Math.pow(Math.sin(t + 0.1), 8); // Quick second beat
    const beatScale = baseScale * (1 + (beat1 + beat2) * beatStrength);
    
    heartEarth.scale.set(beatScale, beatScale, beatScale);
    
    // Add subtle rotation for more life-like movement
    heartEarth.rotation.y += 0.001;
    heartEarth.rotation.x = Math.sin(elapsedTime * 0.5) * 0.05;
}
    // Update controls
    controls.update()

    // Render
    // renderer.render(scene, camera)
    composer.render()

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

}


// Add star and heart geometry functions for confetti variety
function createStarGeometry(size = 0.05) {
    const shape = new THREE.Shape();
    const spikes = 5;
    const outerRadius = size;
    const innerRadius = size * 0.5;
    for (let i = 0; i < spikes * 2; i++) {
        const angle = (i / (spikes * 2)) * Math.PI * 2;
        const r = i % 2 === 0 ? outerRadius : innerRadius;
        const x = Math.cos(angle) * r;
        const y = Math.sin(angle) * r;
        if (i === 0) shape.moveTo(x, y);
        else shape.lineTo(x, y);
    }
    shape.closePath();
    return new THREE.ShapeGeometry(shape);
}
function createHeartGeometry(size = 0.05) {
    const x = 0, y = 0;
    const heartShape = new THREE.Shape();
    heartShape.moveTo(x, y + size * 0.25);
    heartShape.bezierCurveTo(x, y + size, x - size, y + size, x - size, y + size * 0.25);
    heartShape.bezierCurveTo(x - size, y - size * 0.25, x, y - size * 0.5, x, y - size);
    heartShape.bezierCurveTo(x, y - size * 0.5, x + size, y - size * 0.25, x + size, y + size * 0.25);
    heartShape.bezierCurveTo(x + size, y + size, x, y + size, x, y + size * 0.25);
    return new THREE.ShapeGeometry(heartShape);
}

// Add candle flame shader and mesh to each cake
// const flameVertexShader = `
//     varying vec2 vUv;
//     void main() {
//         vUv = uv;
//         gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
//     }
// `;
// const flameFragmentShader = `
//     uniform float time;
//     varying vec2 vUv;
//     void main() {
//         float flicker = 0.7 + 0.3 * sin(time * 10.0 + vUv.x * 20.0 + vUv.y * 20.0);
//         float dist = distance(vUv, vec2(0.5, 0.5));
//         float alpha = smoothstep(0.3, 0.0, dist);
//         vec3 color = mix(vec3(1.0, 0.8, 0.2), vec3(1.0, 0.4, 0.0), dist);
//         gl_FragColor = vec4(color * flicker, alpha * flicker);
//     }
// `;